var _g, _g2, _path, _path2, _g3, _g4, _g5, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampfirePoints0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 135,
    viewBox: "0 0 80 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter0_df)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.1502 37.3036C46.4266 45.0641 40.8595 49.6386 36.7485 53.7686L24.6033 62.8769C28.4072 55.626 38.5151 42.3348 40.013 33.8918C41.5109 25.4489 39.9938 15.7579 39.048 11.9677C42.0502 17.1795 47.8738 29.5431 47.1502 37.3036Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter1_df)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5573 56.2414C21.1661 49.7026 23.9042 43.8775 25.6379 38.9693L31.9453 26.9645C31.6559 34.273 28.5957 48.8718 30.6237 56.2581C32.6518 63.6444 37.591 70.8819 39.807 73.5773C35.3868 70.5232 25.9485 62.7802 23.5573 56.2414Z",
    fill: "#B1C4D2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.452133 104.157C1.08344 99.6694 5.23289 96.5435 9.72018 97.1748L72.4795 106.004C76.9668 106.636 80.0927 110.785 79.4614 115.272C78.8301 119.76 74.6806 122.886 70.1933 122.254L7.43399 113.425C2.9467 112.793 -0.179178 108.644 0.452133 104.157Z",
    fill: "#AA8C71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66936 125.633C2.62911 121.969 3.94611 117.344 7.61096 115.303L57.1995 87.6972C60.8643 85.6569 65.4892 86.9739 67.5295 90.6388L68.1128 91.6866C70.1531 95.3514 68.8361 99.9763 65.1712 102.017L15.5827 129.623C11.9178 131.663 7.29292 130.346 5.25267 126.681L4.66936 125.633Z",
    fill: "url(#paint0_radial)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.006 97.4743C47.1652 102.775 40.7511 106.188 35.4484 106.839C26.7953 106.839 23.0923 97.5494 23.0947 91.8761C23.0972 85.9459 32.6591 78.5577 35.4484 74.5598C37.6798 71.3615 37.6136 69.2951 37.6136 66.6367C40.2703 68.536 41.8876 74.6826 44.9223 78.4975C48.1764 82.5884 48.8468 92.1736 48.006 97.4743Z",
    fill: "#F86B2F"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2935 89.6634C23.5314 93.6716 29.2956 100.2 32.4307 103.344C34.1608 104.564 35.8136 104.791 38.5762 103.866C46.3499 101.265 41.4558 94.7678 43.224 89.1687C44.3112 85.726 42.2945 77.8413 39.8544 74.8781C38.7227 73.142 38.5762 74.8794 38.5762 77.3184C38.5762 85.8699 31.9962 84.6531 27.2935 89.6634Z",
    fill: "#F8C02F"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.2602 102.719C38.5532 102.677 39.4591 99.3725 39.0926 97.5991C38.7261 95.8258 37.1535 93.5444 36.9702 91.4159C36.7869 89.2873 37.3085 88.2793 37.3085 88.2793C37.3085 88.2793 35.4306 91.8411 35.0399 93.5134C34.6493 95.1857 35.2942 97.2951 34.3776 97.5991C33.461 97.9032 31.9398 96.7375 32.3071 97.5991C32.6743 98.4608 33.4887 102.769 36.2602 102.719Z",
    fill: "#FFE840"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8628 122.762C18.8628 127.283 15.1984 130.947 10.678 130.947C6.15764 130.947 2.49316 127.283 2.49316 122.762C2.49316 118.242 6.15764 114.578 10.678 114.578C15.1984 114.578 18.8628 118.242 18.8628 122.762Z",
    fill: "#CAA17A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6928 122.762C17.6928 126.629 14.5583 129.763 10.6916 129.763C6.82498 129.763 3.69043 126.629 3.69043 122.762C3.69043 118.895 6.82498 115.761 10.6916 115.761C14.5583 115.761 17.6928 118.895 17.6928 122.762Z",
    fill: "#D1B295"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df",
    x: 13.6035,
    y: 0.967773,
    width: 44.6085,
    height: 72.9092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect2_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df",
    x: 12.6201,
    y: 16.9644,
    width: 37.1866,
    height: 66.6129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 11.0947,
    y: 56.6367,
    width: 49.2419,
    height: 64.2022,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.562667 0 0 0 0 0.184314 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 23.0615,
    y: 73.1758,
    width: 23.4644,
    height: 36.2578,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.972549 0 0 0 0 0.562667 0 0 0 0 0.184314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 28.251,
    y: 84.2793,
    width: 14.9205,
    height: 22.4403,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.25098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.9759 97.1933) rotate(109.009) scale(25.6802 39.1744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA8C71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9A17B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfirePoints0);
export default __webpack_public_path__ + "static/media/campfire-points-0.2687e7f685a48e043cbea743806ae80c.svg";
export { ForwardRef as ReactComponent };